import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "follow-contents" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "sp-wrapper-right" }
const _hoisted_5 = { class: "content-item-title" }
const _hoisted_6 = { class: "tag-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "sp-wrapper-bottom" }
const _hoisted_12 = { class: "content-item-date" }
const _hoisted_13 = { class: "content-item-writer" }
const _hoisted_14 = { class: "writer-name" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "like-button" }
const _hoisted_17 = ["id", "checked", "onChange"]
const _hoisted_18 = ["for"]
const _hoisted_19 = ["id", "checked", "onChange"]
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "content-none" }
const _hoisted_22 = { class: "follow-content-none-text" }

import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Content } from "@/models/contents/content";
import { UserArticleFavorite } from "@/models/users/articleFavorite";
import { UserArticleLike } from "@/models/users/articleLikes";
import Pagination from "@/views/base/Pagination.vue";
import { processend, processing } from "@/utils/view";
import { _$t } from "@/utils/i18n";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import ModalSearch from "@/components/modules/article/ModalSearch.vue";

// ---- interface ----------------------------------------------
interface ArticleData {
  articleId: number;
  title: string;
  contentType: number;
  coverPhotoUrl: string;
  likeCount: number;
  dateFirstPublished: string;
  tags: {
    tagId: number;
    tagName: string;
  }[];
  diseases: {
    diseaseCode: string;
    diseaseName: string;
  }[];
  poster: {
    adminId: number;
    nickname: string;
  };
  isNew: boolean;
  isFavorite: boolean;
  isLiked: boolean;
}

interface ArticleQueryCond {
  tagIds?: number[];
  diseaseCodes?: string[];
  posterIds?: number[];
}
// ---- Constant ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'Follow',
  setup(__props) {

const router = useRouter();
const userArticleFavorite = new UserArticleFavorite();
const userArticleLike = new UserArticleLike();
const data = new Content();
const searchModalOpen = ref(false);
const listData = ref<ArticleData[]>([]);
const isFetched = ref(false);
const isDataShow = ref(false);
const isPaginationShow = ref(false);
const expandedItems = reactive<{ [key: string]: boolean }>({});
const tagListRefs = reactive({});

// ---- variable ----------------------------------------------
let props = reactive({
  cond: { searchType: 2, searchValue: 0 }, // APIの検索条件
  size: 12,
  getTotalCount: (cond: any): Promise<number> => {
    return data.getArticlesCount(cond);
  },
  getPageData: (page: number, size: number, cond: any): Promise<any> => {
    return data.getArticles(page, size, cond);
  },
});
// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});
// ---- Function ----------------------------------------------
// アコーディオン高さのチェック（高さ>135px)
const checkTagListHeight = (articleId: string | number): boolean => {
  const tagList = tagListRefs[articleId];
  if (tagList) {
    // total height ul (diseases and tags)
    const totalHeight = tagList.scrollHeight;
    return totalHeight > 135;
  }
  return false;
};

// トグルボタンの状態
const toggleExpand = (articleId: string | number) => {
  if (expandedItems[articleId]) {
    expandedItems[articleId] = false;
  } else {
    expandedItems[articleId] = true;
  }
};

// 一覧データ取得
const notify = async (result: any) => {
  if (result.isSuccess) {
    listData.value = result.data;
    isDataShow.value = listData.value.length != 0;
    isFetched.value = true;
    await new Promise((resolve) => setTimeout(resolve, 150)); // 150ms delay
    isPaginationShow.value = true;
    window.scrollTo({ top: 0 });
  } else {
    listData.value = [];
    const status = result.data.error?.response?.status;
    // セッションエラー
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        result.data.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// 記事一覧ページへ遷移
const goToArticlePage = (cond?: ArticleQueryCond) => {
  router.push({
    name: "article/search",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};
// 記事お気に入り更新
const updateUserArticleFavorites = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleFavorite
    .updateUserArticleFavorites(articleId)
    .then(([model, _response, err]) => {
      if (err) {
        target.checked = !target.checked;
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        target.checked = result;

        const article = listData.value.find((a) => a.articleId === articleId);
        if (article) {
          article.isFavorite = result;
        }
      }
    });
};

// 記事いいね情報更新
const updateUserArticleLikes = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleLike
    .updateUserArticleLikes(articleId, !target.checked)
    .then(([model, _response, err]) => {
      if (err) {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const likeCount = model.attributes?.result;
        const article = listData.value.find((a) => a.articleId === articleId);
        if (article) {
          article.likeCount = likeCount;
          article.isLiked = !article.isLiked;
        }
      }
    });
};

// 記事詳細ページへ遷移
const goToArticleDetailPage = (articleId: number) => {
  if (!articleId) return;

  router.push({
    name: "article/detail",
    params: { articleId },
  });
};

// タイトルを38文字以内に…で切り捨てる
const truncateTitle = (title: string): string => {
  if (!title) return "";

  if (title.length > 38) {
    return title.slice(0, 37) + "…";
  }

  return title;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isFetched.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (article, i) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "follow-contents-items",
                key: article.articleId
              }, [
                _createElementVNode("div", {
                  class: "sp-wrapper",
                  onClick: ($event: any) => (goToArticleDetailPage(article.articleId))
                }, [
                  _createElementVNode("img", {
                    class: "content-item-img",
                    src: article.coverPhotoUrl
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-item-new", { none: !article.isNew }])
                    }, _toDisplayString(article.isNew ? _ctx.$t("article_new") : ""), 3),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(truncateTitle(article.title)), 1)
                  ])
                ], 8, _hoisted_2),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", {
                    class: _normalizeClass(["content-item-tags", { heightExpanded: expandedItems[article.articleId] }]),
                    ref_for: true,
                    ref: (el) => (tagListRefs[article.articleId] = el)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.diseases, (disease, j) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "tag-item tag-disease",
                        key: j,
                        onClick: ($event: any) => (goToArticlePage({ diseaseCodes: [disease.diseaseCode] }))
                      }, _toDisplayString(disease.diseaseName), 9, _hoisted_7))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, j) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "tag-item tag-interest",
                        key: j,
                        onClick: ($event: any) => (goToArticlePage({ tagIds: [tag.tagId] }))
                      }, _toDisplayString(tag.tagName), 9, _hoisted_8))
                    }), 128))
                  ], 2),
                  (checkTagListHeight(article.articleId))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!expandedItems[article.articleId])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "contents-height-all",
                              onClick: ($event: any) => (toggleExpand(article.articleId))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
                              _cache[2] || (_cache[2] = _createElementVNode("img", {
                                src: "/server/necs/images/arrow-right_icon.png",
                                alt: "Show more"
                              }, null, -1))
                            ], 8, _hoisted_9))
                          : _createCommentVNode("", true),
                        (expandedItems[article.articleId])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "contents-height-hide",
                              onClick: ($event: any) => (toggleExpand(article.articleId))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
                              _cache[3] || (_cache[3] = _createElementVNode("img", {
                                src: "/server/necs/images/arrow-right_icon.png",
                                alt: "Show less"
                              }, null, -1))
                            ], 8, _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(article.dateFirstPublished), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("article_poster")) + "：", 1),
                      _createElementVNode("span", {
                        class: "writer-name-area",
                        onClick: ($event: any) => (
                  goToArticlePage({ posterIds: [article.poster.adminId] })
                )
                      }, _toDisplayString(article.poster.nickname), 9, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "writer-like",
                        id: `like-toggle${i}`,
                        checked: article.isLiked,
                        onChange: (e) => updateUserArticleLikes(article.articleId, e)
                      }, null, 40, _hoisted_17),
                      _createElementVNode("label", {
                        for: `like-toggle${i}`,
                        class: "like-icon"
                      }, null, 8, _hoisted_18),
                      _withDirectives(_createElementVNode("p", null, "いいね", 512), [
                        [_vShow, article.likeCount === 0]
                      ]),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(article.likeCount), 513), [
                        [_vShow, article.likeCount > 0]
                      ])
                    ]),
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "writer-follow",
                      id: `follow-toggle${i}`,
                      checked: article.isFavorite,
                      onChange: (e) => updateUserArticleFavorites(article.articleId, e)
                    }, null, 40, _hoisted_19),
                    _createElementVNode("label", {
                      for: `follow-toggle${i}`,
                      class: "follow-icon"
                    }, null, 8, _hoisted_20)
                  ])
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, isDataShow.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.$t("article_tab_follow_no_data1")), 1),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("article_tab_follow_no_data2")), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              class: "follow-content-none-img",
              src: "/server/necs/images/follow_empty_img.png",
              alt: ""
            }, null, -1))
          ], 512), [
            [_vShow, !isDataShow.value]
          ])
        ], 64))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(Pagination, _mergeProps(_unref(props), { onNotify: notify }), null, 16), [
      [_vShow, isPaginationShow.value && isDataShow.value]
    ]),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      class: "contents-list-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (searchModalOpen.value = true))
    }, [
      _cache[6] || (_cache[6] = _createElementVNode("img", { src: "/server/necs/images/article_search_button_icon.svg" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_search_all")), 1)
    ], 512), [
      [_vShow, isPaginationShow.value]
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 1 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (searchModalOpen.value)
      ? (_openBlock(), _createBlock(ModalSearch, {
          key: 2,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (searchModalOpen.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})